export default "__VITE_ASSET__c5334653__"